// Konfiguracja wykresu zakupów dla karty klienta (Panel Handlowca)

import { IWiseChartParameter } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

/**
 * Funkcja tworząca konfigurację parametrów dla wykresu zakupów
 * @param t - funkcja tłumaczeń
 */
export const getTraderClientCardChartParameters = (
  t: (key: string) => string
): IWiseChartParameter[] => {
  return [
    {
      type: 'date_range',
      label: t('Zakres dat'),
      field_symbol: 'date_range',
      default_value: ''
    }
  ];
};

/**
 * Parametry do pobierania danych dla wykresu zakupów (karta klienta)
 */
export const traderClientCardChartLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/clients/:clientId/sales',
  params_list: null
};
